<template>
    <div class="relative" ref="container">
        <textarea
            :class="[inputClasses, 'resize-y', 'h-48', {error: error}]"
            v-model.lazy="value"
            ref="input"
            @focus="focus"
            @blur="blur"
        ></textarea>

        <label 
            @click="focus"
            :class="labelClasses"
            ref="placeholder"
        >
            {{ placeholder }}
        </label>
    </div>
</template>
<script>
import inputs from '@/Mixins/inputs.js';

export default {
    mixins: [inputs],

    computed: {
        
    }
};
</script>

<style scoped>
.error {
    @apply border-danger;
}
</style>
